<template>
  <div class="tabbarPage">
    <div class="my_tabbar flex-between">
      <div
        class="my_tabba_item"
        v-for="(item, index) in tabList"
        :key="index + 'a'"
        :class="{ active: tabbarActive == index }"
        @click="handleNavBar(index)"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tabbar",
  data() {
    return {
      tabList: ["首页", "业务管理", "消息中心", "个人中心"],
      tabbarActive: 0,
    };
  },
  created() {
    this.$watch(() => {
      if (this.$route.path == "/mine") {
        this.tabbarActive = 3;
      } else if (this.$route.path == "/home") {
        this.tabbarActive = 0;
      } else if (this.$route.path == "/businessCenter") {
        this.tabbarActive = 1;
      }
    });
  },
  methods: {
    handleNavBar(index) {
      if (this.$route.path == "/home" && index == 0) {
        this.tabbarActive = 0;
        return;
      }
      if (this.$route.path == "/businessCenter" && index == 1) {
        this.tabbarActive = 1;
        return;
      }
      if (this.$route.path == "/mine" && index == 3) {
        this.tabbarActive = 3;
        return;
      }
      if (index == 0) {
        this.tabbarActive = index;
        this.$router.push("/home");
      } else if (index == 1) {
        this.tabbarActive = index;
        this.$router.push("/businessCenter");
      } else if (index == 3) {
        this.tabbarActive = index;
        this.$router.push("/mine");
      } else {
        this.$toast("即将开放");
      }
    },
  },
};
</script>

<style lang='less' scoped>
.tabbarPage {
  width: 750px;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  height: 123px;
  font-size: 24px;
  color: #000000;
  border-top: 1px solid #c9c9c9;
  background: #fff;
  z-index: 1000001;
  .my_tabbar {
    height: 100%;
    .my_tabba_item {
      border-right: 1px solid #c9c9c9;
      text-align: center;
      height: 100%;
      line-height: 123px;
      flex: 1;
      &:last-child {
        border-right: none;
      }
      &.active {
        color: #eb1b3d;
      }
    }
  }
}
</style>